module.exports = __webpack_public_path__ + "img/imagem-modal.4f04be4d.svg";